import { render, staticRenderFns } from "./ProposalDetailCredentials.vue?vue&type=template&id=364d67f0"
import script from "./ProposalDetailCredentials.vue?vue&type=script&lang=js"
export * from "./ProposalDetailCredentials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports